var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352 128A128 128 0 1 1 224 0a128 128 0 0 1 128 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M313.6 288h-16.7a174.1 174.1 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-41.6A134.43 134.43 0 0 0 313.6 288z","className":"fa-primary","key":2})]);
}

User.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = User;

User.default = User;
